/* eslint-disable no-plusplus */
export function getCurrentStepBySlug(
	slug: string | null,
	list: string[] | string[][] | string[][][]
): number {
	if (!slug) {
		return 0;
	}
	let index: number | null = null;
	for (let i = 0; i < list.length; i++) {
		if (Array.isArray(list[i])) {
			for (let j = 0; j < list[i].length; j++) {
				if (list[i][j] === slug) {
					index = i;
					break;
				}
			}
		} else if (list[i] === slug) {
			index = i;
			break;
		}
	}

	if (index === null) {
		throw new Error(`Step with slug ${slug} not found in list ${list}`);
	}

	return index;
}
